import React, { Component } from 'react';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import AspModal from './components/AspModal/AspModal';

const withNetworkHandler = (WrappedComponent, axios) => {
    return (class extends Component {

        state = {
            error: null,
            isLoading: false
        }

        componentWillMount() {

            axios.interceptors.request.use(request => {
                this.setState({ isLoading: true });
                return request;
            });

            axios.interceptors.response.use(response => {
                this.setState({ isLoading: false });
                return response;
            });

            axios.interceptors.response.use(request => {
                this.setState({ error: null });
                return request;
            });

            // axios.interceptors.request.use(
            //     config => {
            //         const token = this.props.oktaAuthState?.accessToken.accessToken;
            //         if (token) {
            //             config.headers['Authorization'] = 'Bearer ' + token;
            //         }
            //         return config;
            //     },
            //     error => {
            //         Promise.reject(error)
            // });

            axios.interceptors.response.use(res => res, error => {
                this.setState({ error: error, isLoading: false })
            });
        }

        errorConfirmedHandler = () => {
            this.setState({ error: null })
        }

        shouldDisplay(){
            if(this.state.error)
                return true
        }

        render() {
            return (
                <div>
                    {this.shouldDisplay() && <AspModal
                        // show={this.state.error ? true : false}
                        show={this.shouldDisplay()}
                        okButtonHandler={this.errorConfirmedHandler}
                        color="#CC0000"
                        size="7x"
                        icon={faTimesCircle}
                        displayText1="We are experiencing technical difficulties."
                        displayText2="Please try again later."
                        buttonText1="OK">
                        {this.state.error ? this.state.error.message : null}
                    </AspModal>}
                    <WrappedComponent {...this.props} />
                </div>
            )
        }

    })
}

export default withNetworkHandler;